import Avatar from '@material-ui/core/Avatar';
import SyncIcon from '@material-ui/icons/Sync';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from '../style/gstheme';

class IntegrationCard extends React.Component {

  selectIntegration = () => this.props.onSelectIntegration(this.props.id);

  render() {

    const { classes, name, isSelected } = this.props;

    return (
      <Card
        tabIndex={0}
        data-test={name}
        className={isSelected ? classes.gsSelectedCard : classes.gsCard}
        onKeyDown={(ev) => {
          if (ev.key === "Enter") {
            ev.preventDefault();
            ev.stopPropagation();
            this.selectIntegration();
          }
        }}
        onClick={this.selectIntegration}>
        <CardHeader
          data-test="integration"
          classes={{
            root: classes.gsCardInner
          }}
          titleTypographyProps={{
            className: classes.gsCardHeader
          }}
          avatar={<Avatar className={classes.smallPrimaryAvatar}>
            <SyncIcon />
          </Avatar>
          }
          title={
            <div>
              <div style={{ display: 'flex' }}>
                <div variant="body2" style={{ flex: 1 }}>{name}</div>
              </div>
            </div>}
        />
      </Card>
    );
  }
}

IntegrationCard.defaultProps = {
  isSelected: false
}

IntegrationCard.propTypes = {
  classes: PropTypes.object,
  isSelected: PropTypes.bool,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onSelectIntegration: PropTypes.func.isRequired
}

export default withStyles(styles)(IntegrationCard);